<template>
  <div class="wrap">
    <div class="search-container">
      <el-form ref="form" :model="form" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="商品名称" prop="searchValue">
              <el-input
                clearable
                placeholder="请输入商品名称"
                v-model="form.name"
                :maxlength="8"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="state	" label="状态">
              <el-select clearable v-model="form.state" style="width: 100%">
                <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="text-right">
            <el-button type="primary" @click="searchEvent" class="search-button">{{
              $t("search")
            }}</el-button>
            <el-button type="primary" @click="cleanForm" class="clean-button">{{
              $t("clean")
            }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-container">
      <el-table
        :data="tableData"
        :height="tableHeight - 20"
        style="width: 100%"
        border
        @sort-change="sort_post_change"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="index" align="center" label="序号" width="55"> </el-table-column>
        <el-table-column type="selection" align="center" width="55"> </el-table-column>
        <el-table-column prop="code" align="left" min-width="80" label="编号"> </el-table-column>
        <el-table-column prop="name" align="left" min-width="150" label="商品名称">
        </el-table-column>
        <el-table-column prop="pic" align="left" min-width="120" label="商品图片">
          <template slot-scope="scope">
            <img class="table-img" :src="scope.row.pic" alt="" srcset="">
          </template>
        </el-table-column>
        <el-table-column
          prop="unitText"
          align="left"
          header-align="center"
          min-width="100"
          label="单位"
        >
        </el-table-column>
        <el-table-column
          prop="sellPrice"
          align="center"
          min-width="120"
          show-overflow-tooltip
          label="价格（元）"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="costPrice"
          min-width="120"
          show-overflow-tooltip
          label="成本（元）"
        >
        </el-table-column>
        <el-table-column align="center" prop="stateText" min-width="100" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state === 2">下架</span>
            <span v-else-if="scope.row.state === 1">已上架</span>
            <span v-else>{{scope.row.state}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageination-wrapper">
      <div>
        <el-button
          class="default-button"
          @click="changeAddDialog(true)"
          v-if="buttonAuth.includes('goodsList:add')"
          >{{ $t("add") }}</el-button
        >

        <el-button
          class="default-button"
          :disabled="selectedArr.length !== 1"
          @click="changeAddDialog(true, true, selectedArr[0])"
          v-if="buttonAuth.includes('goodsList:edit')"
          >修改</el-button
        >
        <el-button
          class="default-button"
          @click="openDeleteDialog(selectedArr.map(item => item.id), 9)"
          :disabled="selectedArr.length ===0"
          v-if="buttonAuth.includes('goodsList:upDown')"
        >上架</el-button>
        <el-button
          class="default-button"
          @click="openDeleteDialog(selectedArr.map(item => item.id), 17)"
          :disabled="selectedArr.length ===0"
          v-if="buttonAuth.includes('goodsList:upDown')"
        >下架</el-button>
        <el-button
          class="default-button"
          :disabled="selectedArr.length === 0"
          v-if="buttonAuth.includes('goodsList:delete')"
          @click="openDeleteDialog(selectedArr.map(item => item.id))"
          >{{ $t("delete") }}</el-button
        >
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.pageNum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="form.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="form.total"
      >
      </el-pagination>
    </div>
    <!-- 添加/修改弹窗 -->
    <add-dialog
      ref="addDialog"
      :Language="Language"
      :show="addDialog.visible"
      :isEdit="addDialog.isEdit"
      :statusList="statusList"
      @closeDialog="changeAddDialog"
    ></add-dialog>
    <!-- 删除确认弹窗 -->
    <confirm-dialog
      ref="confirmDialog"
      :Language="Language"
      :show="confirmDialog.visible"
      :type="confirmDialog.type"
      @sureDialog="sureConfirmDialog"
      @closeDialog="changeConfirmDialog"
    ></confirm-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import mixin from "@/mixins/index";
import IndexClass from "./indexClass.js";
import apis from "@/apis";
import addDialog from "./dialog/addDialog.vue";
import confirmDialog from "@/components/confirmDialog.vue";
import { changeInfo } from "@/utils/index";

export default {
  mixins: [mixin],
  components: {
    addDialog,
    confirmDialog,
  },
  data() {
    return {
      form: new IndexClass("form"),
      tableData: [],
      addDialog: {
        visible: false,
        isEdit: false,
      },
      confirmDialog: {
        visible: false,
        type: 1,
        data: {},
      },
      sportNewList: [],
      statusList: [
        {
          value: 1,
          label: "已上架",
        },
        {
          value: 2,
          label: "下架",
        },
      ],
    };
  },
  computed: {
    ...mapState(["Language", "venueId", "DROPDOWNBOX"]),
  },
  methods: {
    /**
     * @function 当确认弹窗点击确定的时候触发
     */
    sureConfirmDialog() {
      // 如果一个页面有多个弹窗，视情况决定用if语句还是二元表达式对api进行判断
      if (
        this.confirmDialog.type === 9
        || this.confirmDialog.type === 17
      ) {
        this.modelHangOn();
      } else {
        this.$http.post(apis.venueProductInfoDelete, { idList: this.confirmDialog.data.ids }).then((res) => {
        if (res.data.code === 0) {
          if (this.confirmDialog.type === 1) {
            this.$message.success('删除成功！');
          }
          this.$refs.confirmDialog.closeDialog();
        }
      });
      }
    },
    // 上下架
    modelHangOn() {
      let state = "";
      if (this.confirmDialog.type === 9) {
        state = 1;
      } else {
        state = 2;
      }
      this.$http
        .post(apis.venueProductInfoUpDown, {
          idList: this.confirmDialog.data.ids,
          state,
        })
        .then((res) => {
          if (res.data.code === 0) {
            if (this.confirmDialog.type === 9) {
              this.$message.success("上架成功!");
            } else {
              this.$message.success("下架成功!");
            }
            this.$refs.confirmDialog.closeDialog();
            this.searchData();
          }
        });
    },
    /**
     * @function 改变确认/删除弹窗的状态
     * @param {Boolean} dialogStatus 是否展示当前弹窗
     * @param {Number} type 打开的弹窗类型，1为删除确认
     */
    changeConfirmDialog(dialogStatus, type = 1) {
      this.confirmDialog.type = type;
      this.confirmDialog.visible = dialogStatus;
      if (!dialogStatus) {
        this.confirmDialog.data.ids = "";
        this.searchEvent();
      }
    },
    /**
     * @function 打开删除弹窗
     * @param {Array} id 选中的ID数组
     */
    openDeleteDialog(id, type = 1) {
      if (id.length === 0) {
        this.$message.error("请先选择数据");
        return;
      }
      this.confirmDialog.type = type;
      this.confirmDialog.data.ids = id;
      this.changeConfirmDialog(true, type);
    },
    /**
     * @function 改变新增/修改弹窗的状态
     * @param {Boolean} dialogStatus 是否展示当前弹窗
     * @param {Boolean} isEdit 是否是修改弹窗，如果是则要调用接口，进行回显
     * @param {Object} data 修改回显时，传给后端的值
     */
    changeAddDialog(dialogStatus, isEdit = false, data) {
      if (dialogStatus) {
        this.addDialog.isEdit = isEdit;
        if (isEdit) {
          // 调用vuex里面的获取数据的业务，如果要在这里写接口，需要改成Promise
          this.$refs["addDialog"].getDataQuery(data);
        }
        // 这么写才不会影响最后的初始化，如果赋值完直接打开，会影响最后的初始化
      } else {
        this.searchEvent();
      }
      this.$nextTick(() => {
        this.addDialog.visible = dialogStatus;
      });
    },
    /**
     * @function 搜索方法
     */
    searchData() {
      this.$http.post(apis.venueProductInfoPage, this.form).then((res) => {
        if (res.data.code === 0) {
          this.tableData = res.data.rows && res.data.rows.map((item) => {
            item.stateText = changeInfo(item.state, this.statusList, "value", "label");
            item.unitText = changeInfo(item.unit, this.DROPDOWNBOX.PRODUCT_UNIT, "value", "label");
            return item;
          });
          this.form.total = res.data.total;
        }
      });
    },
    /**
     * @function 清空搜索栏
     */
    cleanForm() {
      this.form = new IndexClass("form");
      this.$nextTick(() => {
        this.searchEvent();
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/styles/mixin.scoped.less";
.search-wrapper {
  width: 100%;
}
.pageination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px;
}
.table-img {
  width: 50px;
  height: 50px;
}
</style>
<style lang="less">
@import "../../../assets/styles/mixin.less";
</style>
